import React from 'react'
import MultiValueSelector from "../common/editors/MultiValueSelector";

export default function FacetParentsSelector({value, onChange, ... other}) {
  let facetOptions = ['Make:', 'Model:', 'Engine:'];

  return <MultiValueSelector value={value} onChange={onChange} options={facetOptions} {... other}/>
}
